"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeographyAdminApi = exports.GeographyAdminApiFactory = exports.GeographyAdminApiFp = exports.GeographyAdminApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
const common_1 = require("../common");
const base_1 = require("../base");
const GeographyAdminApiAxiosParamCreator = function (configuration) {
    return {
        geographyAdminV1FreePostalCodesGet: async (options = {}) => {
            const localVarPath = `/geography/admin/v1/free-postal-codes`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyAdminV1GeodataWithoutPolygonsGet: async (options = {}) => {
            const localVarPath = `/geography/admin/v1/geodata-without-polygons`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyAdminV1IdDelete: async (id, options = {}) => {
            (0, common_1.assertParamExists)('geographyAdminV1IdDelete', 'id', id);
            const localVarPath = `/geography/admin/v1/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyAdminV1ImportGeodataPost: async (file, options = {}) => {
            (0, common_1.assertParamExists)('geographyAdminV1ImportGeodataPost', 'file', file);
            const localVarPath = `/geography/admin/v1/import-geodata`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyAdminV1PolygonsWithoutGeodataGet: async (options = {}) => {
            const localVarPath = `/geography/admin/v1/polygons-without-geodata`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyAdminV1UploadGeodataToS3Post: async (options = {}) => {
            const localVarPath = `/geography/admin/v1/upload-geodata-to-s3`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyAdminV1WrongPostalCodesGet: async (options = {}) => {
            const localVarPath = `/geography/admin/v1/wrong-postal-codes`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.GeographyAdminApiAxiosParamCreator = GeographyAdminApiAxiosParamCreator;
const GeographyAdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GeographyAdminApiAxiosParamCreator)(configuration);
    return {
        async geographyAdminV1FreePostalCodesGet(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1FreePostalCodesGet(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1FreePostalCodesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyAdminV1GeodataWithoutPolygonsGet(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1GeodataWithoutPolygonsGet(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1GeodataWithoutPolygonsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyAdminV1IdDelete(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1IdDelete(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1IdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyAdminV1ImportGeodataPost(file, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1ImportGeodataPost(file, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1ImportGeodataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyAdminV1PolygonsWithoutGeodataGet(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1PolygonsWithoutGeodataGet(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1PolygonsWithoutGeodataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyAdminV1UploadGeodataToS3Post(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1UploadGeodataToS3Post(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1UploadGeodataToS3Post']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyAdminV1WrongPostalCodesGet(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyAdminV1WrongPostalCodesGet(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyAdminApi.geographyAdminV1WrongPostalCodesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.GeographyAdminApiFp = GeographyAdminApiFp;
const GeographyAdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GeographyAdminApiFp)(configuration);
    return {
        geographyAdminV1FreePostalCodesGet(options) {
            return localVarFp.geographyAdminV1FreePostalCodesGet(options).then((request) => request(axios, basePath));
        },
        geographyAdminV1GeodataWithoutPolygonsGet(options) {
            return localVarFp.geographyAdminV1GeodataWithoutPolygonsGet(options).then((request) => request(axios, basePath));
        },
        geographyAdminV1IdDelete(id, options) {
            return localVarFp.geographyAdminV1IdDelete(id, options).then((request) => request(axios, basePath));
        },
        geographyAdminV1ImportGeodataPost(file, options) {
            return localVarFp.geographyAdminV1ImportGeodataPost(file, options).then((request) => request(axios, basePath));
        },
        geographyAdminV1PolygonsWithoutGeodataGet(options) {
            return localVarFp.geographyAdminV1PolygonsWithoutGeodataGet(options).then((request) => request(axios, basePath));
        },
        geographyAdminV1UploadGeodataToS3Post(options) {
            return localVarFp.geographyAdminV1UploadGeodataToS3Post(options).then((request) => request(axios, basePath));
        },
        geographyAdminV1WrongPostalCodesGet(options) {
            return localVarFp.geographyAdminV1WrongPostalCodesGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.GeographyAdminApiFactory = GeographyAdminApiFactory;
class GeographyAdminApi extends base_1.BaseAPI {
    geographyAdminV1FreePostalCodesGet(options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1FreePostalCodesGet(options).then((request) => request(this.axios, this.basePath));
    }
    geographyAdminV1GeodataWithoutPolygonsGet(options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1GeodataWithoutPolygonsGet(options).then((request) => request(this.axios, this.basePath));
    }
    geographyAdminV1IdDelete(id, options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1IdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    geographyAdminV1ImportGeodataPost(file, options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1ImportGeodataPost(file, options).then((request) => request(this.axios, this.basePath));
    }
    geographyAdminV1PolygonsWithoutGeodataGet(options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1PolygonsWithoutGeodataGet(options).then((request) => request(this.axios, this.basePath));
    }
    geographyAdminV1UploadGeodataToS3Post(options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1UploadGeodataToS3Post(options).then((request) => request(this.axios, this.basePath));
    }
    geographyAdminV1WrongPostalCodesGet(options) {
        return (0, exports.GeographyAdminApiFp)(this.configuration).geographyAdminV1WrongPostalCodesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GeographyAdminApi = GeographyAdminApi;
//# sourceMappingURL=geography-admin-api.js.map